 
import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import {
  OrganizationsFetchAction,
  OrganizationsFetchAllSuccessAction,
  OrganizationsFetchSuccessAction,
  OrganizationsState,
} from './organizations.types';

const initialState: OrganizationsState = {
  institutions: [],
  institutionsAll: [],
  currentPage: 0,
  totalPages: 1,
  loading: false,
  error: undefined,
};

const { actReq, act, actReject, actResolve } =
  makeActionCreator<OrganizationsState>();

export const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    fetchOrganizations: actReq<OrganizationsFetchAction['payload']>(),
    fetchOrganizationsSuccess: act<OrganizationsFetchSuccessAction['payload']>(
      ({ currentPage, institutions, totalPages }) => ({
        institutions,
        currentPage,
        totalPages,
      })
    ),
    fetchOrganizationsFailure: actReject(),
    fetchAllOrganizations: actReq(),
    fetchAllOrganizationsSuccess:
      actResolve<OrganizationsFetchAllSuccessAction['payload']>(
        'institutionsAll'
      ),
    fetchAllOrganizationsFailure: actReject(),
  },
});

export const {
  fetchOrganizations,
  fetchOrganizationsSuccess,
  fetchOrganizationsFailure,
  fetchAllOrganizations,
  fetchAllOrganizationsFailure,
  fetchAllOrganizationsSuccess,
} = organizationsSlice.actions;

export const actions = {
  ...organizationsSlice.actions,
};

export const useOrganizationsSlice = createSliceHook(
  organizationsSlice.name,
  actions
);
